import { ImageFragment } from '@/graphql/fragments/image';
import { PodcastBaseFragment } from '@/graphql/fragments/posdcast';
import { ResourceBaseFragment } from '@/graphql/fragments/resource';
import { gql } from '@apollo/client';

export const QUERY_SEARCH_FETCH_PAGE = gql`
  query fetchSearchPage {
    searchPage {
      data {
        id
        attributes {
          title
          searchBtn
          yourResultsTitle
          noRecordsFoundText
          moreBtn
        }
      }
    }
  }
`;

export const QUERY_FETCH_SEARCH_COURSE_PAGEABLE = gql`
  query fetchSearchCoursesPageable($page: Int!, $search: String) {
    courses(
      pagination: { pageSize: 4, page: $page }
      filters: { or: [{ title: { containsi: $search } }, { description: { containsi: $search } }] }
      publicationState: LIVE
    ) {
      data {
        id
        attributes {
          title
          slug
          description
          duration
          thumbnail {
            data {
              ...ImageFragment
            }
          }
          type {
            data {
              attributes {
                name
              }
            }
          }
          course_category {
            data {
              attributes {
                name
                description
              }
            }
          }
          modules {
            id
            lessons {
              id
              authors {
                data {
                  attributes {
                    name
                    role
                    bio
                    avatar {
                      data {
                        ...ImageFragment
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${ImageFragment}
`;

export const QUERY_FETCH_RESOURCES_PAGEABLE = gql`
  query fetchSearchLatestResourcesWithoutMetaPageable($page: Int!, $search: String) {
    resources(
      pagination: { pageSize: 4, page: $page }
      filters: { or: [{ title: { containsi: $search } }, { briefDescription: { containsi: $search } }] }
    ) {
      data {
        id
        attributes {
          ...ResourceBaseFragment
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${ResourceBaseFragment}
  ${ImageFragment}
`;

export const QUERY_FETCH_PODCASTS_PAGEABLE = gql`
  query fetchSearchPodcastsPageable($page: Int, $search: String, $userId: ID) {
    podcasts(
      pagination: { page: $page, pageSize: 4 }
      filters: { or: [{ title: { containsi: $search } }, { briefDescription: { containsi: $search } }] }
      sort: "publicationDate:desc"
    ) {
      data {
        id
        attributes {
          ...PodcastBaseFragment
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
  ${PodcastBaseFragment}
`;

export const QUERY_FETCH_SEARCH_COURSE_PREDICT = gql`
  query fetchSearchCoursesPredictPageable($page: Int!, $search: String) {
    courses(
      pagination: { pageSize: 4, page: $page }
      filters: { title: { containsi: $search } }
      publicationState: LIVE
    ) {
      data {
        id
        attributes {
          title
          slug
          description
        }
      }
    }
  }
`;

export const QUERY_FETCH_RESOURCES_PREDICT = gql`
  query fetchSearchLatestResourcesPageable($page: Int!, $search: String, $topic: String) {
    resources(
      pagination: { pageSize: 4, page: $page }
      filters: { title: { containsi: $search }, themes: { topic: { topic: { eq: $topic } } } }
    ) {
      data {
        id
        attributes {
          title
          briefDescription
        }
      }
      meta {
        pagination {
          page
          pageCount
          total
        }
      }
    }
  }
`;

export const QUERY_FETCH_PODCASTS_PREDICT = gql`
  query fetchSearchPodcastsWihoutMetaPageable($page: Int, $search: String) {
    podcasts(
      pagination: { page: $page, pageSize: 4 }
      filters: { title: { containsi: $search } }
      sort: "publicationDate:desc"
    ) {
      data {
        id
        attributes {
          title
          briefDescription
        }
      }
    }
  }
`;
